<template>
  <el-container class="nav-el-container" style=" height: 100%;">
    <el-header
      class="nav-header-bg nav-pd0 tob_tw"
      style="background-color: #fff;box-shadow: darkgrey -5px -2px 4px 2px;"
    >
      <el-row class="box-wts">
        <el-col class="wts" :span="10">
          <router-link :to="{name:'Home'}">
            <div class="nav-pd nav-image" style="text-align: right;">
              <img src="../assets/img/logo-eimskip2.png" />
            </div>
          </router-link>
        </el-col>
        <!-- <el-col :span="14">
          <div
            class
            style="padding: 20px;text-align: left;color: #1b1464;"
            v-if="$route.name=='Login'"
          >欢迎登录</div>
          <div
            class
            style="padding: 20px;text-align: left;color: #1b1464;"
            v-else-if="$route.name=='Register'"
          >欢迎注册</div>
          <div
            class
            style="padding: 20px;text-align: left;color: #1b1464;"
            v-else-if="$route.name=='ForgetPassword'"
          >找回密码</div>
          <div
            class
            style="padding: 20px;text-align: left;color: #1b1464;"
            v-else="$route.name=='Invite'"
          >邀请注册</div>
        </el-col>-->
        <!--<el-col :span="7">-->
        <!--<div class="" style="color: #fff;padding: 20px;font-size: 13px;" v-if="$route.name=='Register'|| $route.name=='ForgetPassword'">-->
        <!--<span class="">已有账号，</span>-->
        <!--<router-link :to="{name:'Login'}" style="color: #fff;">-->
        <!--<span class="">马上登陆</span>-->
        <!--</router-link>-->
        <!--</div>-->
        <!--</el-col>-->
      </el-row>
    </el-header>
    <el-main class="nav-pd0" style="margin-top:60px;">
      <router-view></router-view>
    </el-main>
    <el-footer class="nav-pd0 new-nav-footer" style="height: 80px;">
      <div class="nav-footer">
        <div class="nav-font-footer" align="center">
          © Copyright 2012-2019 中航运捷运物流（上海）有限公司 版权所有 著作权与商标声明
          <a
            class="nav-font-footer"
            href="https://www.beian.gov.cn/portal/registerSystemInfo?spm=a3c00.7621333.7y9jhqsfz.111.62a7XmdaXmdaqK"
            target="_blank"
          >鲁ICP备19061212号-1</a>
        </div>
        <div style="padding-top:5px;">
          <a
            class="nav-font-footer"
            :underline="false"
            href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
            target="_blank"
          >
            <img class="party" src="../assets/img/party2.gif" alt />
            <img class="party" src="../assets/img/party.png" alt />
            沪公网安备 31011502016842号
          </a>
        </div>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.box-wts {
  width: 1200px;
  margin: 0 auto;
}
.wts {
  width: 150px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/NewMenuTabs.vue